
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.499 4.756a2.2 2.2 0 10-3.112-3.112L8.37 12.66l3.111 3.112L22.5 4.756z","stroke":"#2E3438","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M18.287 2.745l3.111 3.111M4.074 18.6h-.73a2.2 2.2 0 100 4.4h15.401M8.37 12.66l-1.363 4.474 4.474-1.363-3.111-3.11z","stroke":"#2E3438","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10.31 11.194l8.615-8.36L21.31 5.18l-8.318 8.654-2.682-2.64z","fill":"#2E3438"}})])
          )
        }
      }
    